import React from 'react';
import PropTypes from 'prop-types';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { SidebarPortal } from '@plone/volto/components';
import Schema from './schema';
import CitacaoView from './View';

/** Edit da Citação: o desenho do View e os campos na barra lateral. */
const CitacaoEdit = ({ data, onChangeBlock, block, selected }) => {
  const schema = Schema();
  return (
    <>
      <CitacaoView
        data={data}
        vazio={
          <p className="ag-citacao__vazio">
            Citação: escreva a fala, o nome e o cargo na barra lateral.
          </p>
        }
      />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

CitacaoEdit.propTypes = {
  data: PropTypes.object.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  block: PropTypes.string.isRequired,
  selected: PropTypes.bool,
};

export default CitacaoEdit;
